/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientMapping } from '../../models/client-mapping';

export interface ClientManagementSaveMappingSaveMappingPost$Params {
      body?: ClientMapping
}

export function clientManagementSaveMappingSaveMappingPost(http: HttpClient, rootUrl: string, params?: ClientManagementSaveMappingSaveMappingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, clientManagementSaveMappingSaveMappingPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

clientManagementSaveMappingSaveMappingPost.PATH = '/ClientManagement/SaveMapping/SaveMapping';
